export default "__VITE_ASSET__BI7zDbzf__"